import * as types from './types';
import { startSubmit, stopSubmit } from 'redux-form';
import { createToast, toastType } from '../../../common/ToastHelper';
import { getMessageFromResponse } from '../../../components/messages/ApiResultMessage';

export const postImportSiteFile = formData => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(startSubmit('ImportSiteForm'));

    MPWWebApi.importSiteApi
      .postImportSiteFile(formData)
      .then(response => {
        dispatch({
          type: types.IMPORTSITE_IMPORT,
          payload: response,
        });
        dispatch(stopSubmit('ImportSiteForm'));
        const msg = getMessageFromResponse(response);
        msg.forEach(x => {
          createToast(toastType.success, x.Title, x.Message);
        });
      })
      .catch(error => {
        dispatch({
          type: types.IMPORTSITE_ERROR,
          payload: error.response,
        });
        dispatch(stopSubmit('ImportSiteForm'));
      });
  };
};

export const clearImportSiteErrors = () => {
  return {
    type: types.IMPORTSITE_CLEAR_ERROR,
  };
};

export const clearImportSiteData = () => {
  return {
    type: types.IMPORTSITE_CLEAR_DATA,
  };
};

export const setImportSiteErrors = message => {
  return {
    type: types.IMPORTSITE_ERROR,
    payload: {
      data: {
        Errors: [{ Title: 'Error', Message: `${message}`, Scenario: null }],
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/pages/importsite/state/actions.js